function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconFoodBreakfastVoucherFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 14V6a2 2 0 00-2-2H4a2 2 0 00-2 2v8a2 2 0 110 4v8a2 2 0 002 2h24a2 2 0 002-2v-8a2 2 0 010-4zm-2-1.463a4 4 0 000 6.926V26H4v-6.537a3.999 3.999 0 000-6.926V6h24v6.537z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.738 13.952a1 1 0 01.762-.352h8.81a1 1 0 01.987 1.16l-1.46 9.01a1 1 0 01-.987.84h-5.89a1 1 0 01-.987-.84l-1.46-9.01a1 1 0 01.225-.808zm1.937 1.648l1.136 7.01h4.188l1.136-7.01h-6.46z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.412 15.165h.66l.041.005c1.726.202 3.12 1.606 3.12 3.378 0 1.916-1.632 3.414-3.556 3.414h-.014c-.136 0-.295 0-.483-.029l-.68-.105.912-6.663zm1.197 1.575l-.518 3.785c1.01-.184 1.741-1.026 1.741-1.977 0-.78-.486-1.48-1.223-1.808zM16.015 8.77c.244-.652.87-1.096 1.62-1.096v1.4c-.177 0-.274.092-.309.186-.029.078-.053.27.2.523.653.614.766 1.424.428 2.088a1.934 1.934 0 01-1.72 1.03v-1.4c.225 0 .403-.13.473-.266a.262.262 0 00.028-.172c-.01-.052-.044-.145-.171-.263l-.007-.007-.007-.006c-.595-.586-.785-1.349-.535-2.017zM12.486 8.77c.244-.652.871-1.096 1.62-1.096v1.4c-.176 0-.273.092-.308.186-.03.078-.053.27.2.523.653.614.766 1.424.428 2.088a1.933 1.933 0 01-1.72 1.03v-1.4c.224 0 .403-.13.473-.266a.263.263 0 00.028-.172c-.01-.052-.045-.145-.171-.263l-.007-.007-.007-.006c-.596-.586-.785-1.349-.536-2.017z",
    fill: props.color
  }));
}

export default SvgIconFoodBreakfastVoucherFilled;